<template>
  <div>
    <b-card>
      <titleSection
        title="Preguntas frecuentes"
        subtitle="Preguntas relacionadas a la inscripción"
        icon="HelpCircleIcon"
      />

      <app-collapse
        class="mt-2"
        accordion
        type="border"
      >
        <app-collapse-item
          v-for="(ques, index) in preguntas"
          :key="index"
          :title="ques.pregunta"
        >
          <!-- eslint-disable vue/no-v-html -->
          <div v-html="ques.respuesta" />
          <!-- eslint-enable -->
        </app-collapse-item>
      </app-collapse>
      <p class="m-2">¿Tienes más dudas? Visita nuesto apartado de
        <router-link :to="{ name: 'public-faq'}">
          ayuda
        </router-link>, seguro encontrarás mas información.</p>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import titleSection from '@/views/components/title-section.vue'

export default {
  components: {
    titleSection,
    BCard,
    AppCollapse,
    AppCollapseItem,
  },
  data() {
    return {
      preguntas: [
        {
          pregunta: '1 - Selección',
          respuesta:
                'Una vez que seleccionaste lo que deseas estudiar, da clic en <b class="text-color=success">“Solicitud de admisión”</b>',
        },
        {
          pregunta: '2 - Formulario pre - registro',
          respuesta:
                'Completa el formulario de tu pre-registro. <br><br> <b>Nota 1)</b> Para seleccionar la <b>dependencia y entidad federativa</b>, escribe sobre el campo el RFC que corresponde; (el sistema hace una búsqueda de las dependencias y entidades disponibles) selecciona el correcto. Si no sabes el RFC de tu dependencia, pregunta dentro de tu institución. Si no lo encuentras dentro de nuestro sistema, por favor comunicate con nosotros. <br><br> <b> Nota 2) </b> Si no cuentas con segundo nombre y/o apellido materno, deja los campos vacíos. <br><br> <b>Nota 3)</b> ¡Cuidado! Es importante que antes de enviar tu solicitud de admisión, revises el correo electrónico que diste de alta; éste no debe de tener errores, es nuestro medio de comunicación contigo y es utilizado para los próximos pasos de tu inscripción.',
        },
        {
          pregunta: '3 - Notificación correo eléctronico',
          respuesta:
                'Revisa la bandeja de tu correo electrónico (o spam), busca el correo que enviamos de parte de Campus Intetec, revisa los datos y sigue las instrucciones',
        },
        {
          pregunta: '4 - Formulario de registro',
          respuesta:
                'El correo electrónico del paso 3 te da acceso a completar tu solicitud de admisión, llena todos los campos que se te piden y da clic en terminar.',
        },
        {
          pregunta: '5 - Validación de datos',
          respuesta:
                'Servicio Escolar validará la información de tu inscripción. Nos comunicaremos contigo lo más pronto posible para seguir con el proceso de inscripción.',
        },
      ],
    }
  },
}
</script>
